export default "__VITE_ASSET__D$IV2gLQ__"